import { Stack, Tooltip, Typography } from '@mui/material';
import { Provider } from '@repo/api-gw-sdk';

import { Icon } from '@/components/shared/icon';
import { Tag } from '@/components/tag';

export const EonTagRemark = ({
  provider = Provider.Aws,
}: {
  provider?: Provider;
}) => {
  const tagValue =
    provider === Provider.Gcp ? 'eon-restore=true' : 'eon:restore=true';
  const term = provider === Provider.Gcp ? 'label' : 'tag';
  const text = `Eon's restore ${term} will be added.`;

  return (
    <Stack alignItems='center' direction='row'>
      <Typography className='mr-[12px]'>{text}</Typography>
      <Tag variant='outlined' content={tagValue} />
      <Tooltip
        slotProps={{
          tooltip: {
            sx: {
              padding: '16px',
            },
          },
        }}
        title={`By using the ${term}, you can identify the resources you've restored.`}
      >
        <Icon iconClass='material-symbols-help-outline-rounded' />
      </Tooltip>
    </Stack>
  );
};
